import _ from 'lodash';
import path from 'path';
// import platform from 'platform';
import { message } from 'antd';
import Api from '../services/api';
import ExtensionCloud from '../services/extension/extension.cloud';
import RequestStatus from '../constant/request';
import CONSTANT from '../constant';
import { isWeb, isLocal, isForExt, isInternational } from './env';
import Subscribe from './subscribe';

/**
 * 获取 URL 参数
 *
 * @param {any} search
 * @param {any} name
 * @returns
 */
export const getQueryString = (search, name) => {
    var reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    var r = (search || window.location.search).substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
};
/**
 * 解析查询字符串
 *
 * @param {any} search
 * @returns
 */
export const parseQueryString = (search) => {
    var pairs = (search || location.search).slice(1).split('&');
    var result = {};
    pairs.forEach(function (pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return result;
};
/**
 * A request dispatch
 *
 * @param {any} serviceName
 * @param {any} actionType
 * @param {any} requestApi
 * @param {any} formData
 * @param {any} successCb
 * @param {any} failCb
 * @returns dispatch execute function
 */
export const requestDispatch = (serviceName, actionType, requestApi, formData, successCb, failCb) => {
    const state = {
        type: actionType,
        status: RequestStatus.PENDING
    };
    return dispatch => {
        dispatch(state);
        Api[serviceName][requestApi](formData).then(res => {
            state.status = RequestStatus.DONE;
            state.data = res;
            dispatch(state);
            _.isFunction(successCb) && successCb(res);
        }, data => {
            state.status = RequestStatus.FAILED;
            state.data = data;
            dispatch(state);
            _.isFunction(failCb) && failCb(data);
        });
    };
};
/**
 * A request dispatch
 *
 * @param {any} actionType
 * @param {any} serviceName
 * @param {any} requestApi
 * @param {any} formData
 * @param {any} successCb
 * @param {any} failCb
 * @returns dispatch execute function
 */
export const requestDispatch2 = (actionType, serviceName, requestApi, formData, successCb, failCb) => {
    const state = {
        type: actionType,
        payload: {
            status: RequestStatus.PENDING
        }
    };
    return dispatch => {
        dispatch(state);
        Api[serviceName][requestApi](formData).then(res => {
            state.payload.status = RequestStatus.DONE;
            state.payload.data = res;
            dispatch(state);
            _.isFunction(successCb) && successCb(res);
        }, data => {
            state.payload.status = RequestStatus.FAILED;
            state.payload.data = data;
            dispatch(state);
            _.isFunction(failCb) && failCb(data);
        });
    };
};
/**
 * 请求状态
 *
 * @param {any} state
 * @param {any} action
 * @param {any} key
 * @returns
 */
export const requestState = (state, action, key) => {
    // 处理 无网络情况下退出登录
    if ((action.status === RequestStatus.PENDING || (action.data && action.data.code === 99999))) {
        return Object.assign({}, state, {
            ...state,
            [key]: action.status,
            code: action.data && action.data.code
        });
    }
};
/**
 * 获取文件后缀
 *
 * @param {any} name
 * @returns
 */
export const getFileSuffix = (name) => {
    try {
        return path.extname(name).replace('.', '');
    } catch (error) {
        return '';
    }
    // let suffix = '';
    // if (_.isString(name) && name.indexOf('.') !== -1) {
    //     let arr = name.split('.');
    //     suffix = arr[arr.length - 1];
    // }
    // return suffix;
};
/**
 * 获取文件名
 *
 * @param {any} filePath
 * @returns
 */
export const getFileName = (filePath) => {
    try {
        let fp = filePath.replace(/\\/g, '/');
        return path.basename(fp).replace(path.extname(fp), '');
    } catch (error) {
        return filePath;
    }
    // try {
    //     filePath = filePath.replace(/^.*[\\/]/, '');
    //     const fname = filePath.split('.');
    //     if (fname.length > 1) {
    //         fname.pop();
    //     }
    //     return fname.join('');
    // } catch (error) {
    //     console.warn(error);
    //     return '';
    // }
};
/**
 * 是否是苹果电脑
 *
 * @returns
 */
export const hasDarwin = () => {
    return navigator.platform.toLowerCase().indexOf('mac') === 0;
};
/**
 * 下载文件
 *
 * @param {any} blob
 * @param {any} filename
 * @returns
 */
export const forceDownload = (blob, filename) => {
    const url = (window.URL || window.webkitURL).createObjectURL(blob);
    const link = window.document.querySelector('#DownloadFileTarget');
    link.href = url;
    link.download = filename;
    link.click();
    (window.URL || window.webkitURL).revokeObjectURL(url);
    return Promise.resolve();
    // var click = document.createEvent('Event');
    // click.initEvent('click', true, true);
    // link.dispatchEvent(click);
    // return Promise.resolve();
};
/**
 * 检测是否支持 WebGL
 *
 * @returns
 */
export const detectWebGLContext = () => {
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (gl && gl instanceof WebGLRenderingContext) {
        return true;
    } else {
        return false;
    }
};
/**
 * 执行 Checker 直到返回成功
 *
 * @param {IGetReadyChecker} checker
 * @returns
 */
export const getReady = (checker) => {
    return new Promise((resolve) => {
        let timer = null;
        const check = () => {
            timer = requestAnimationFrame(check);
            if (checker()) {
                cancelAnimationFrame(timer);
                resolve();
            }
        };
        check();
    });
};
/**
 * 加载 Js
 *
 * @param {any} url
 * @returns
 */
export const requestExt = async (url, isAbsolutePath = false, id) => {
    if (url) {
        if (!window.require) {
            await getReady(() => window.require !== undefined);
        }
        return new Promise((resolve, reject) => {
            try {
                window.require([isAbsolutePath ? url : getExtResPath(url, id)], (args) => {
                    resolve(args);
                }, (error) => {
                    console.warn('window.require.error ---->', error);
                    reject(error);
                });
            } catch (error) {
                console.warn(error);
                reject(error);
            }
        });
    }
};

export const getExtResPath = (url = '', id) => {
    try {
        if (/^(http|https)/.test(url)) {
            if (isForExt() && getFileSuffix(url) === 'js') {
                return `${url}?v=${+new Date()}`;
            }
            return url;
        }
        if (id) {
            const ext = ExtensionCloud.getExt(id);
            if (isLocal()) {
                let localPath = './exts/';
                return `${localPath}${url}`;
            }
            if (ext && ext.extractPath) {
                return `${ext.extractPath}${url}`;
            }
        }
        return `${ExtensionCloud.extractPath}${url}`;
    } catch (error) {
        console.warn(error);
        return url;
    }
};

/**
  * 错误提示信息
  *
  * @param {any} code
  * @param {any} key
  */
export const showErrorMessage = function (key, code) {
    if (code) {
        const msgKey = `MSG.${code}`;
        if (_.has(this.props.intlr.messages, msgKey)) {
            message.error(this.props.intlr.messages[msgKey]);
        }
    } else {
        message.error(this.props.intlr.messages[key]);
    }
};

/**
 * 成功信息提示
 *
 * @param {any} key
 * @param {any} duration
 */
export const showSuccessMessage = function (key, duration) {
    message.success(this.props.intlr.messages[key], duration);
};

/**
 * 等待
 *
 * @param {number} duration
 * @returns
 */
export const sleep = (duration) => {
    return new Promise(resolve => setTimeout(resolve, duration));
};



/**
 * 字符串格式化
 */
String.prototype.format = function () {
    if (arguments.length == 0) return this;
    for (var s = this, i = 0; i < arguments.length; i++) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i]);
    }
    return s;
};

/**
 * 帧动画
 *
 * @author LiHuan
 * @export
 * @class AnimationFrame
 */
export class AnimationFrame {
    /**
     * Creates an instance of AnimationFrame.
     * @author LiHuan
     * @param {number} [fps=60]
     * @param {() => void} animate
     */
    constructor(fps = 60, animate) {
        this.requestID = 0;
        this.fps = fps;
        this.animate = animate;
        this.isStop = false;
    }
    /**
     * 开始动画
     *
     * @author LiHuan
     */
    start() {
        this.isStop = false;
        let then = performance.now();
        const tolerance = 0.1;
        const animateLoop = (now) => {
            if (this.isStop) {
                this.stop();
                return;
            }
            this.requestID = requestAnimationFrame(animateLoop);
            const delta = now - then;
            const interval = 1000 / this.fps;
            if (delta >= interval - tolerance) {
                then = now - (delta % interval);
                this.animate(delta);
            }
        };
        this.requestID = requestAnimationFrame(animateLoop);
    }
    /**
     * 停止动画
     *
     * @author LiHuan
     */
    stop() {
        this.isStop = true;
        cancelAnimationFrame(this.requestID);
    }
}

/**
 * buffer转base64
 *
 * @param {any} buffer
 */
export const bufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
};

/**
 * 获取 base64
 *
 * @param {any} img
 * @param {any} callback
 */
export const getBase64 = (img, isSvg) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => {
            console.warn(error);
            reject(error);
        };
        reader.addEventListener('load', () => resolve(reader.result));
        if (isSvg) {
            reader.readAsText(img);
        } else {
            reader.readAsDataURL(img);
        }
    });
};

/**
 * 读取数据为 buffer
 *
 * @param {any} data
 * @returns
 */
export const readAsArrayBuffer = (data) => {
    if (data instanceof Blob) {
        return new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => {
                resolve(Buffer.from(new Uint8Array(fr.result)));
            };
            fr.onerror = (err) => {
                reject(err);
            };
            fr.readAsArrayBuffer(data);
        });
    }
    return data;
};

/**
 * 获取图片尺寸信息
 *
 * @param {any} url
 * @returns
 */
export const getImageSize = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = function () {
            resolve({
                width: this.width,
                height: this.height
            });
        };
        img.onerror = function (error) {
            console.warn(error);
            reject(error);
        };
    });
};

/**
 * 通过将 图片 URL 转换成 base64图片
 *
 * @param {any} imageUrl
 * @returns
 */
export const getBase64ImageFromUrl = async (imageUrl) => {
    const res = await fetch(imageUrl);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', function () {
            resolve(reader.result);
        }, false);
        reader.onerror = () => {
            return reject(this);
        };
        reader.readAsDataURL(blob);
    });
};

/**
 * 通过将 base64图片 转换成 blob
 *
 * @param {any} imageUrl
 * @returns
 */
export const base64ToBlob = (urlData) => {
    let arr = urlData.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    // 去掉url的头，并转化为byte
    let bytes = window.atob(arr[1]);
    // 处理异常,将ascii码小于0的转换为大于0
    let ab = new ArrayBuffer(bytes.length);
    // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    let ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
        type: mime
    });
};

/**
 * 选择项目文件打开
 *
 * @returns
 */
export const openProjectTarget = (inputDomId) => {
    inputDomId = typeof inputDomId === 'string' ? inputDomId : '#OpenProjectTarget';
    return new Promise((resolve, reject) => {
        const target = document.querySelector(inputDomId);
        target.click();
        target.onchange = () => {
            const files = target.files;
            if (files instanceof FileList && files.length > 0) {
                const file = files[0];
                if (CONSTANT.PROJECT_SUFFIX.indexOf(getFileSuffix(file.name)) !== -1) {
                    resolve(files[0]);
                } else {
                    reject();
                }
            } else {
                reject();
            }
            target.value = '';
        };
    });
};

/**
 * 根据是否国际化版本转换url
 *
 * @returns
 */
export const translateRequestUrlForEU = (url) => {
    if (isInternational()) {
        if (IS_BUILD_PRODUCTION) {
            if (url.indexOf('//apimblock.makeblock.com/') !== -1) {
                url = url.replace('apimblock', 'api.mblock');
            }
            // 这两个 api 是不用添加 eu
            if (url.indexOf('//extservice.makeblock.com/') === -1 && url.indexOf('//planet.mblock.cc/') === -1) {
                url = url.replace('//', '//eu.');
            }
        }
    }
    return url;
};

/**
 * 判断当前环境是否有网
 *
 * @returns
 */
export const isOnline = () => {
    return window.navigator.onLine;
};

/**
 * 根据运行环境转换route
 *
 * @returns
 */
export const parseRoute = (route) => {
    if (!isWeb()) {
        route = '/list' + route;
    }
    return route;
};

/**
 * 生成id
 *
 * @returns
 */
export const genId = () => {
    var x = '0123456789qwertyuioplkjhgfdsazxcvbnm';
    var tmp = '';
    var timestamp = new Date().getTime();
    for (var i = 0; i < 4; i++) {
        tmp += x.charAt(Math.ceil(Math.random() * 100000000) % x.length);
    }
    return timestamp + tmp;
};

/**
 * 时间戳转为日期
 *
 * @returns
 */
export const formatDate = (time) => {
    const fillZero = (n) => (n).toString().length === 1 ? ('0' + n) : n;
    const d = new Date(time * 1000);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const date = d.getDate();
    const hours = d.getHours();
    const minutes = d.getMinutes();
    const seconds = d.getSeconds();
    return `${year}-${fillZero(month)}-${fillZero(date)} ${fillZero(hours)}:${fillZero(minutes)}:${fillZero(seconds)}`;
};


/**
 * 读取文件为 arrayBuffer
 *
 * @returns
 */
export const readFile = async (path) => {
    return new Promise((resolve, reject) => {
        let oReq = new XMLHttpRequest();
        oReq.open('GET', path, true);
        oReq.responseType = 'blob';
        oReq.onload = function () {
            let data = oReq.response;
            let reader = new FileReader();
            reader.readAsArrayBuffer(data);
            reader.onload = async () => {
                resolve(reader.result);
                clearInterval(watcher);
                watcher = null;
            };
        };
        oReq.onprogress = updateProgress;
        function updateProgress(event) {
            if (event.lengthComputable) {
                var completedPercent = Math.floor(event.loaded / event.total * 100);
                console.log('finish download progress：', completedPercent);
                Subscribe.trigger('file_download', completedPercent);
                oReq.loadTime = +new Date;
            }
        }
        let watcher = setInterval(() => {
            const now = +new Date;
            if (oReq.loadTime && (now - oReq.loadTime > CONSTANT.PROJECT_SAVE_TIMEOUT)) {
                handleExec('network error');
            }
        }, 1000);
        oReq.onerror = (err) => {
            handleExec(err);
        };
        try {
            oReq.send();
        } catch (err) {
            handleExec(err);
        }
        function handleExec(errorMsg) {
            console.log(errorMsg);
            oReq.abort();
            clearInterval(watcher);
            watcher = null;
            Subscribe.trigger('file_download_error');
            reject(errorMsg);
        }
    });
};

export const blob2ArrayBuffer = async (blob) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        reader.onload = function () {
            let buf = reader.result;
            resolve(buf);
        };
        reader.onerror = (err) => {
            reject(err);
        };
    });
};

/**
 *
 * @param {String} urlpath 例如: cloudProjectId=1234
 */
export const getUrlParams = (urlpath) => {
    let url = urlpath || window.location.href.split('?')[1];
    if (!url) {
        return null;
    }
    let map = _.chain(url)
        .split('&')
        .map(_.partial(_.split, _, '=', 2))
        .fromPairs()
        .value();
    return map;
};

export const safeHttps = (httpUrl) => {
    if(typeof httpUrl !== 'string') return httpUrl;
    if(httpUrl.indexOf('http') !== -1) {
        return httpUrl.replace('http:', 'https:');
    }
    return httpUrl;
};